import { setUnauthorizedCallback } from "../api/client";
import { useAuthProfessionalStore } from "./authProfessionalStore";

export async function initAuthProfessional() {
  setUnauthorizedCallback(() => {
    useAuthProfessionalStore.getState().clearAuth();
  });
  useAuthProfessionalStore.setState({ isLoading: true });
  await useAuthProfessionalStore.getState().initAuth();
}
